export default "__VITE_ASSET__CO_RqksR__"